import { StoreState } from "@/store";
import { PortfolioExportState } from "@/store/slices/portfolioExport";

export const selectSummaryStatusModal = (state: StoreState): PortfolioExportState["summaryStatusModal"] => {
  return state.portfolioExport.summaryStatusModal;
};
